<script setup lang="ts">
import { ref } from "vue"
import { useRouter } from "vue-router"
import { login } from "../api/auth"
import { NCard, NButton, NInput, NAlert, NForm, NFormItem } from 'naive-ui'

const username = ref("")
const password = ref("")
const error = ref<string | null>(null)
const loading = ref(false)
const router = useRouter()

async function handleLogin() {
  if (!username.value || !password.value) return
  error.value = null
  loading.value = true
  try {
    await login(username.value, password.value)
    router.push({ name: 'Map' })
  } catch {
    error.value = "Érvénytelen felhasználónév vagy jelszó."
  } finally {
    loading.value = false
  }
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Enter') handleLogin()
}
</script>

<template>
  <div class="login-page">
    <div class="login-wrapper">
      <div class="login-branding">
        <a href="https://biokutatas.hu" target="_blank">
          <img src="/omki_logo_positive.svg" alt="ÖMKi" class="login-logo" />
        </a>
        <h1 class="login-title">Élő Labor Platform</h1>
        <p class="login-subtitle">Üdvözöljük! Kérjük, jelentkezzen be a folytatáshoz.</p>
      </div>

      <n-card class="login-card" :bordered="false">
        <n-alert
          v-if="error"
          type="error"
          :title="error"
          style="margin-bottom: 20px"
        />

        <n-form @keydown="onKeydown">
          <n-form-item label="Felhasználónév" :show-feedback="false" style="margin-bottom: 16px">
            <n-input
              v-model:value="username"
              placeholder="Felhasználónév"
              size="large"
              :disabled="loading"
              autofocus
            />
          </n-form-item>

          <n-form-item label="Jelszó" :show-feedback="false" style="margin-bottom: 24px">
            <n-input
              v-model:value="password"
              type="password"
              placeholder="Jelszó"
              size="large"
              :disabled="loading"
              show-password-on="click"
            />
          </n-form-item>

          <n-button
            type="primary"
            size="large"
            block
            :loading="loading"
            @click="handleLogin"
          >
            Bejelentkezés
          </n-button>
        </n-form>
      </n-card>
    </div>
  </div>
</template>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0faf4 0%, #e6f7ed 50%, #d4f0e0 100%);
  padding: 24px;
}

.login-wrapper {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}

.login-branding {
  text-align: center;
}

.login-logo {
  height: 56px;
  margin-bottom: 16px;
}

.login-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #18a058;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

.login-subtitle {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
}

.login-card {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);
  padding: 8px;
}
</style>
